import React, { Component } from 'react'
import PropTypes from 'prop-types'
import IPropTypes from 'react-immutable-proptypes'
import { FormattedMessage } from 'react-intl'

import hocConnect from './hocConnect'
import HocDialogComponent from '../../../../services/dialog/hocDialogComponent'

import ImportPreloader from './components/ImportPreloader'
import ImportResultsTable from './components/ImportResultsTable'
import ImportContent from './components/ImportContent'

import { LOCALE_PREFIX } from './constants'

import './style.scss'

@hocConnect
@HocDialogComponent
export default class GroupMembersImport extends Component {
    static propTypes = {
        closeDialog: PropTypes.func.isRequired,
        duplicated: PropTypes.number.isRequired,
        exists: PropTypes.number.isRequired,
        forceRenderDialogComponent: PropTypes.func.isRequired,
        imported: PropTypes.bool.isRequired,
        importGroupMembers: PropTypes.func.isRequired,
        importing: PropTypes.bool.isRequired,
        importResults: IPropTypes.list.isRequired,
        loading: PropTypes.bool.isRequired,
        notFound: PropTypes.number.isRequired,
        ok: PropTypes.number.isRequired,
        setupImportResultsState: PropTypes.func.isRequired,
        total: PropTypes.number.isRequired,
        type: PropTypes.string.isRequired,
    }

    componentDidUpdate(prevProps) {
        const { imported, forceRenderDialogComponent } = this.props

        if (imported !== prevProps.imported) {
            // fix issue when text of dialog component doesn't change
            forceRenderDialogComponent()
        }
    }

    componentWillUnmount() {
        const { setupImportResultsState } = this.props

        setupImportResultsState([], false, { imported: false })
    }

    onButtonClick = (buttonType) => {
        if (buttonType === 'close') {
            const { type, closeDialog } = this.props

            closeDialog(type)
        }
    }

    defineHeader = () => {
        const { imported } = this.props

        const text = !imported ? 'headerTitle' : 'headerTitleResults'

        return {
            text: <FormattedMessage id={`${LOCALE_PREFIX}.${text}`} />,
            icon: 'import',
        }
    }

    defineFooter = () => {
        const { imported } = this.props

        const text = !imported ? 'close' : 'ok'

        return [
            {
                type: 'close',
                text: <FormattedMessage id={`${LOCALE_PREFIX}.${text}`} />,
            },
        ]
    }

    renderContent = () => {
        const {
            importResults,
            importing,
            importGroupMembers,
            loading,
            duplicated,
            exists,
            notFound,
            imported,
            ok,
            total,
        } = this.props

        if (importing || loading) {
            return <ImportPreloader />
        }

        if (!imported) {
            return <ImportContent importGroupMembers={importGroupMembers} />
        }

        return (
            <ImportResultsTable
                importResults={importResults}
                duplicated={duplicated}
                exists={exists}
                notFound={notFound}
                ok={ok}
                total={total}
            />
        )
    }

    render() {
        return <div className="group-members-import">{this.renderContent()}</div>
    }
}
